module.exports = __webpack_public_path__ + "50c0a7ac1ae9215cc549ebd18b075e3b.MP3";